module.exports = __webpack_public_path__ + "img/5.27eb30d5.png";